module.exports = __webpack_public_path__ + "img/big-logo.ed509fda.svg";